(() => {
  const article = document.querySelector('[data-yp-article]');
  if (!article) return;

  const content = article.querySelector('[data-yp-article-content]');
  const toc = article.querySelector('[data-yp-toc]');
  const tocList = article.querySelector('[data-yp-toc-list]');
  const progressBar = document.querySelector('[data-yp-reading-progress]');
  const copyButton = article.querySelector('[data-yp-copy-link]');

  const slugify = (text) => text
    .toLowerCase()
    .trim()
    .replace(/[^\p{L}\p{N}\s-]/gu, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

  if (content && toc && tocList) {
    const headings = Array.from(content.querySelectorAll('h2, h3'));
    const usedIds = new Set();

    headings.forEach((heading, index) => {
      let id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
      const baseId = id;
      let suffix = 2;
      while (usedIds.has(id) || document.querySelectorAll(`#${CSS.escape(id)}`).length > (heading.id ? 1 : 0)) {
        id = `${baseId}-${suffix}`;
        suffix += 1;
      }
      heading.id = id;
      usedIds.add(id);

      const item = document.createElement('li');
      item.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      tocList.appendChild(item);
    });

    if (!headings.length) {
      toc.classList.add('is-empty');
    } else if ('IntersectionObserver' in window) {
      const links = Array.from(tocList.querySelectorAll('a'));
      const linkById = new Map(links.map((link) => [decodeURIComponent(link.hash.slice(1)), link]));
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => link.classList.remove('is-active'));
          const activeLink = linkById.get(entry.target.id);
          if (activeLink) activeLink.classList.add('is-active');
        });
      }, { rootMargin: '-20% 0px -68% 0px', threshold: 0 });
      headings.forEach((heading) => observer.observe(heading));
    }
  }

  const updateProgress = () => {
    if (!content || !progressBar) return;
    const rect = content.getBoundingClientRect();
    const start = window.scrollY + rect.top;
    const distance = Math.max(content.offsetHeight - window.innerHeight, 1);
    const progress = Math.min(Math.max((window.scrollY - start) / distance, 0), 1);
    progressBar.style.width = `${progress * 100}%`;
  };

  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);

  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const originalLabel = copyButton.dataset.copyLabel || 'Copy link';
      const copiedLabel = copyButton.dataset.copiedLabel || 'Copied';
      try {
        await navigator.clipboard.writeText(window.location.href);
        copyButton.textContent = copiedLabel;
        window.setTimeout(() => { copyButton.textContent = originalLabel; }, 1800);
      } catch (error) {
        window.prompt('Copy this link:', window.location.href);
      }
    });
  }
})();
